import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.localStorage
  })],
  state: {
    user: {},
    token: '',
    expiresToken: '',
    company: '',
    userJoin: '',
    tokenJoin: '',
    tab: 0,
    province_th_list: [
      'กรุงเทพมหานคร',
      'กระบี่',
      'กาญจนบุรี',
      'กาฬสินธุ์',
      'กำแพงเพชร',
      'ขอนแก่น',
      'จันทบุรี',
      'ฉะเชิงเทรา',
      'ชลบุรี',
      'ชัยนาท',
      'ชัยภูมิ',
      'ชุมพร',
      'เชียงใหม่',
      'เชียงราย',
      'ตรัง',
      'ตราด',
      'ตาก',
      'นครนายก',
      'นครปฐม',
      'นครพนม',
      'นครราชสีมา',
      'นครศรีธรรมราช',
      'นครสวรรค์',
      'นนทบุรี',
      'นราธิวาส',
      'น่าน',
      'บึงกาฬ',
      'บุรีรัมย์',
      'ปทุมธานี',
      'ประจวบคีรีขันธ์',
      'ปราจีนบุรี',
      'ปัตตานี',
      'พระนครศรีอยุธยา',
      'พะเยา',
      'พังงา',
      'พัทลุง',
      'พิจิตร',
      'พิษณุโลก',
      'เพชรบุรี',
      'เพชรบูรณ์',
      'แพร่',
      'ภูเก็ต',
      'มหาสารคาม',
      'มุกดาหาร',
      'แม่ฮ่องสอน',
      'ยโสธร',
      'ยะลา',
      'ร้อยเอ็ด',
      'ระนอง',
      'ระยอง',
      'ราชบุรี',
      'ลพบุรี',
      'ลำปาง',
      'ลำพูน',
      'เลย',
      'ศรีสะเกษ',
      'สกลนคร',
      'สงขลา',
      'สตูล',
      'สมุทรปราการ',
      'สมุทรสงคราม',
      'สมุทรสาคร',
      'สระแก้ว',
      'สระบุรี',
      'สิงห์บุรี',
      'สุโขทัย',
      'สุพรรณบุรี',
      'สุราษฎร์ธานี',
      'สุรินทร์',
      'หนองคาย',
      'หนองบัวลำภู',
      'อ่างทอง',
      'อำนาจเจริญ',
      'อุดรธานี',
      'อุตรดิตถ์',
      'อุทัยธานี',
      'อุบลราชธานี'
    ],
    permissions: []
  },
  mutations: {
    setStructureId (state, data) {
      localStorage.setItem('structureId', data)
    },
    storeUser (state, data) {
      state.user = data
    },
    clearUser (state) {
      state.user = {}
    },
    storeToken (state, data) {
      state.token = data
    },
    clearToken (state) {
      state.token = ''
    },
    setTab (state, data) {
      state.tab = data
    },
    storeExpiresToken (state, data, role) {
      state.expiresToken = data
    },
    storeCompany (state, data, role) {
      state.company = data
    },
    storeUserJoin (state, data, role) {
      state.userJoin = data
    },
    storeTokenJoin (state, data, role) {
      state.tokenJoin = data
    },
    storeUserRole (state, data) {
      state.userRole = data
    },
    clearExpiresToken (state) {
      state.expiresToken = ''
    },
    clearCompany (state) {
      state.company = ''
    },
    setPermissions (state, data) {
      state.permissions = data
    },
    clearPermissions (state) {
      state.permissions = []
    }
  },
  actions: {
    loginUser (state, data) {
      state.commit('storeUser', data)
    },
    logoutUser (state) {
      state.commit('clearUser')
    },
    loginToken (state, data) {
      state.commit('storeToken', data)
    },
    logoutToken (state) {
      state.commit('clearToken')
    },
    setTab (state, data) {
      state.commit('setTab', data)
    },
    setExpiresToken (state, data) {
      state.commit('storeExpiresToken', data)
    },
    setUserRole (state, data) {
      state.commit('storeUserRole', data)
    },
    clearExpiresToken (state) {
      state.commit('clearExpiresToken')
    },
    setPermissions (state, data) {
      state.commit('setPermissions', data)
    }
  },
  getters: {
    user: state => state.user,
    token: state => state.token,
    expiresToken: state => state.expiresToken,
    company: state => state.company,
    userJoin: state => state.userJoin,
    tokenJoin: state => state.tokenJoin,
    getTab: state => state.tab,
    getPermissionsByRoute: (state) => (fullPath) => {
      if (!fullPath) return
      // ตัด String เอาเฉพาะตัวหน้าสุด (เช่น จาก "/manage/company/123" -> "/manage")
      const segment = fullPath.split('/')[1]
      const basePath = '/' + segment
      const found = state.permissions.find(p => p.link === basePath)
      return found ? found.permission_rights : {
        show: true,
        create: false,
        edit: false,
        del: false,
        upload: false,
        download: false
      }
    }
  }
})
